module.exports = __webpack_public_path__ + "static/media/six1.a24843fa.svg";